import React from 'react';
import { PageHeader, PageTitle } from '../../shared/Page';

const BusinessesPageHeader = () => (
  <PageHeader>
    <PageTitle>Benefits for small business</PageTitle>
  </PageHeader>
);

export { BusinessesPageHeader };